jQuery(($) => {
	$(document).foundation();

	$(document).on('click', '.preventDefault', function(e) {
		e.preventDefault();
	});

	$('#piecejointe').change(function() {
	  var allFile = $('#piecejointe')[0].files;
	  if (allFile.length > 0) {
	  	var file = $('#piecejointe')[0].files[0].name;
	  	$('.customInputName').text(file);
	  } else {
	  	$('.customInputName').empty();
	  }
	});

	$('.liste-clients').slick({
	    slidesToShow: 4,
	    slidesToScroll: 1,
	    autoplay: false,
	    infinite: true,
	    adaptiveHeight: true,
	    nextArrow: '<div class="nav nav-next"></div>',
	    prevArrow: '<div class="nav nav-prev"></div>',
	    responsive: [
		    {
		      breakpoint: 1024,
		      settings: {
		        slidesToShow: 3
		      }
		    },
	        {
	          breakpoint: 640,
	          settings: {
	            slidesToShow: 2
	          }
	        },
	        {
	          breakpoint: 440,
	          settings: {
	            slidesToShow: 1,
	            adaptiveHeight: false
	          }
	        }
	    ]
	});
});


// WEBPACK FOOTER //
// ./js/script.js